<ng-container *ngIf="serverError">
  <div class="modal-header">
    <h4 class="modal-title">Server Error: {{ serverError }}</h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
</ng-container>

<ng-container *ngIf="!serverError">

  <div class="modal-header">
    <h4 class="modal-title">
      Edit Customer Tag
    </h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body">
    <div class="form-group">
      <label>Tag Name</label>
      <input type="text" class="form-control disabled" disabled
             [value]="tagName">
    </div>

    <div class="alert alert-danger" role="alert" *ngIf="errorMessage">
      {{ errorMessage }}
    </div>
  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-danger"
            [disabled]="loadingSubmit"
            [class.disabled]="loadingSubmit"
            (click)="handleRemove()">
      {{ loadingSubmit ? 'Loading...' : 'Remove' }}
    </button>
    <button type="button" class="btn btn-secondary"
            (click)="activeModal.close()">
      Back
    </button>
  </div>

</ng-container>
